export const BLOCKED_NUMBER_CHARACTERS = ['+', '-', 'E', 'e']

export const MAXIMUM_AMOUNT = 9_999.99
